import { mxgraphInstance } from './mxgraphFactory';

/**
 * Editor
 */
export const mxDefaultKeyHandler = mxgraphInstance.mxDefaultKeyHandler;
export const mxDefaultPopupMenu = mxgraphInstance.mxDefaultPopupMenu;
export const mxDefaultToolbar = mxgraphInstance.mxDefaultToolbar;
export const mxEditor = mxgraphInstance.mxEditor;